module.exports = __webpack_public_path__ + "static/media/X5-D.4c7019f0.png";